module.exports = __webpack_public_path__ + "static/media/planning-for-success-large@3x.e63ed7e6.png";